export default __webpack_public_path__ + "static/media/112_mastaar_kawai_0001.397e2914.png";